import React from "react";
import styled from "styled-components";
import { connect } from "react-redux";
import { userStorageUsage, userStorageLimit } from "@kubera/common";
import { withRouter } from "@kubera/common";
import { hashParams, modalValues } from "routes";

export const MaxFileSizeLimit = 50 * 1024 * 1024;

const Container = styled.div`
  display: contents;
`;

const Input = styled.input`
  display: none;
`;

const UploadButton = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const canUploadFiles = (files, storageUsed, storageLimit, history, location) => {
  let currentStorageUsed = storageUsed;

  for (const file of files) {
    if (file.size > MaxFileSizeLimit) {
      history.push({
        ...location,
        hash: `${hashParams.MODAL}=${modalValues.UPLOAD_TOO_LARGE}`
      });
      return false;
    }

    currentStorageUsed = currentStorageUsed + file.size;
  }

  if (currentStorageUsed > storageLimit) {
    history.push({
      ...location,
      hash: `${hashParams.MODAL}=${modalValues.STORAGE_FULL}`
    });
    return false;
  }
  return true;
};

class FileUploadInput extends React.Component {
  constructor(props) {
    super(props);

    this.handleButtonClick = this.handleButtonClick.bind(this);
    this.handleInputChange = this.handleInputChange.bind(this);

    this.inputRef = React.createRef();
  }

  handleInputChange(e) {
    const files = e.target.files;

    if (files && files.length > 0 && this.props.onChange) {
      if (
        canUploadFiles(
          files,
          this.props.storageUsed,
          this.props.storageLimit,
          this.props.history,
          this.props.location
        ) === true
      ) {
        this.props.onChange(files);
      }
    }
  }

  handleButtonClick() {
    if (this.inputRef.current) {
      this.inputRef.current.click();
    }
  }

  reset = () => {
    this.inputRef.current.value = null;
  };

  upload() {
    this.handleButtonClick();
  }

  render() {
    const { className, type, onChange, ...other } = this.props;

    return (
      <Container>
        <UploadButton data-cy="uploadButton" className={className} onClick={this.handleButtonClick}>
          {this.props.label}
        </UploadButton>
        <Input {...other} type="file" data-cy="fileInput" ref={this.inputRef} onChange={this.handleInputChange} />
      </Container>
    );
  }
}

const mapStateToProps = state => ({
  storageUsed: userStorageUsage(state),
  storageLimit: userStorageLimit(state)
});

const withRouterInnerRef = WrappedComponent => {
  class InnerComponentWithRef extends React.Component {
    render() {
      const { forwardRef, ...rest } = this.props;
      return <WrappedComponent {...rest} ref={forwardRef} />;
    }
  }

  const ComponentWithRef = withRouter(InnerComponentWithRef, { withRef: true });

  return React.forwardRef((props, ref) => {
    return <ComponentWithRef {...props} forwardRef={ref} />;
  });
};

const ConnectedFileUploadInput = connect(
  mapStateToProps,
  null,
  null,
  { forwardRef: true }
)(FileUploadInput);
export default withRouterInnerRef(ConnectedFileUploadInput);
